/* tslint:disable */
/* eslint-disable */
import { gql } from "@apollo/client";

export const COMPLETE_ONBOARDING = gql`
  mutation CompleteOnboarding($input: CompleteOnboardingInput!) {
    completeOnboarding(input: $input)
  }
`;
